import { render, staticRenderFns } from "./Notes.html?vue&type=template&id=412d5fa2&scoped=true&external"
import script from "./Notes.js?vue&type=script&lang=js&external"
export * from "./Notes.js?vue&type=script&lang=js&external"
import style0 from "./Notes.scss?vue&type=style&index=0&id=412d5fa2&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "412d5fa2",
  null
  
)

export default component.exports